import React from 'react';

const DefaultTypeNull = props => {
  const { data, schema, path = [] } = props;
  return (
    <div className={`default-type-null depth-${path.length}`}>
      <strong className="default-type-null-title">{schema.title}</strong>{' '}
      <span className="default-type-null-value">{data}</span>
    </div>
  );
};

export default DefaultTypeNull;
